var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_play_button_386234",
    "data-name": "noun_play button_386234",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.293,
    height: 21.293,
    viewBox: "0 0 21.293 21.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M18.742,960.363a10.65,10.65,0,1,0,2.661.364A10.643,10.643,0,0,0,18.742,960.363Zm-2.63,5.83,8.111,4.816-8.111,4.816Z",
    transform: "translate(-8 -960.362)",
    fill: "#07b4e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.3d9dcf05e862750cd3f5cbfb006ce54c.svg";
export { ForwardRef as ReactComponent };